/**
 * Tracks the offset between the backend clock and this device's clock so that
 * a reading captured while offline gets a trustworthy timestamp.
 *
 * On every backend response that carries a `now` (ISO) we re-anchor.
 * capturedNowIso() extrapolates from the last anchor using the monotonic
 * performance clock, so a user changing the device clock mid-session has no effect.
 */
const KEY = 'srvOffsetMs';

let offsetMs = 0;
try {
  offsetMs = Number(localStorage.getItem(KEY) ?? '0') || 0;
} catch {
  /* ignore */
}
let anchorPerf = performance.now();
let anchorServerMs = Date.now() + offsetMs;

export function noteServerTime(iso?: string): void {
  if (!iso) return;
  const serverMs = Date.parse(iso);
  if (Number.isNaN(serverMs)) return;
  offsetMs = serverMs - Date.now();
  anchorPerf = performance.now();
  anchorServerMs = serverMs;
  try {
    localStorage.setItem(KEY, String(offsetMs));
  } catch {
    /* ignore */
  }
}

/** Best estimate of the current backend time as an ISO string. */
export function capturedNowIso(): string {
  const est = anchorServerMs + (performance.now() - anchorPerf);
  return new Date(est).toISOString();
}

export function hasServerAnchor(): boolean {
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return false;
  }
}
